import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditCostProfileRequest(
  resource: Identifiable<Resource>,
  { costProfile, nextCostProfile }: Boundaries["editCostProfile"]["request"],
): Identifiable<Resource> {
  return resource.costProfile && resource.costProfile.uuid === costProfile.uuid
    ? { ...resource, costProfile: { ...costProfile, ...nextCostProfile } }
    : resource;
}

function handleEditCostProfileSuccess(
  resource: Identifiable<Resource>,
  nextCostProfile: Boundaries["editCostProfile"]["success"],
): Identifiable<Resource> {
  return resource.costProfile &&
    resource.costProfile.uuid === nextCostProfile.uuid
    ? { ...resource, costProfile: nextCostProfile }
    : resource;
}

function handleEditCostProfileFailure(
  resource: Identifiable<Resource>,
  { costProfile }: Boundaries["editCostProfile"]["failure"],
): Identifiable<Resource> {
  return resource.costProfile && resource.costProfile.uuid === costProfile.uuid
    ? { ...resource, costProfile }
    : resource;
}

export {
  handleEditCostProfileRequest,
  handleEditCostProfileSuccess,
  handleEditCostProfileFailure,
};
